import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const checkStatusValues = ["pass", "fail", "skip", "error"] as const;
const overallStatusValues = ["pass", "fail", "error"] as const;
const runTriggerValues = ["cron", "admin", "mcp"] as const;

const checkSchema = z.object({
  id: z.string(),
  label: z.string(),
  status: z.enum(checkStatusValues),
  message: z.string().optional(),
});

export const getHsaImplementationVerification = {
  name: "getHsaImplementationVerification" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z
    .object({
      lastRunAt: z.date().nullable(),
      lastRunTrigger: z.enum(runTriggerValues).nullable(),
      overallStatus: z.enum(overallStatusValues).nullable(),
      checks: z.array(checkSchema),
    })
    .nullable(),
};

export const runHsaImplementationVerification = {
  name: "runHsaImplementationVerification" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    teamId: zExt.objectId(),
    teamName: z.string(),
    runAt: z.date(),
    trigger: z.enum(runTriggerValues),
    overallStatus: z.enum(overallStatusValues),
    checks: z.array(checkSchema),
  }),
};
